

import { useNavigate } from 'react-router-dom';

export const Privacy = () => {
    const navigate = useNavigate();
    return (
        <div className="min-h-screen bg-obsidian-900 text-white p-6 md:p-12">
            <div className="max-w-4xl mx-auto">
                <button onClick={() => navigate('/')} className="mb-8 text-volt-400 hover:text-volt-300">← Back to Home</button>
                <h1 className="text-4xl font-bold mb-8">Privacy Policy</h1>
                <div className="space-y-6 text-gray-300">
                    <p>Last updated: December 12, 2025</p>
                    <p>At Forecaster, we take your privacy seriously. This Privacy Policy explains how we collect, use, and protect your information.</p>
                    <h2 className="text-2xl font-bold text-white mt-8">1. Information We Collect</h2>
                    <p>We collect information you provide directly to us, such as when you create an account, subscribe to our newsletter, or contact us for support.</p>
                    <h2 className="text-2xl font-bold text-white mt-8">2. How We Use Information</h2>
                    <p>We use your information to provide, maintain, and improve our services, including to process transactions, send you technical notices, and respond to your comments.</p>
                    <h2 className="text-2xl font-bold text-white mt-8">3. Data Security</h2>
                    <p>We implement appropriate technical and organizational measures to protect your personal data against unauthorized access or disclosure.</p>
                </div>
            </div>
        </div>
    );
};
